var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatLogoHuge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 206,
    viewBox: "0 0 172 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.399 119.493C172.076 117.663 171.053 115.667 169.198 115.064L142.316 106.329C140.46 105.727 138.478 106.748 137.753 108.559C133.525 119.119 125.996 128.072 116.244 134.048C105.485 140.641 92.7264 143.179 80.2632 141.205C67.8 139.231 56.4501 132.874 48.255 123.279C40.0599 113.684 35.5574 101.48 35.5574 88.8609C35.5574 76.2424 40.0599 64.0379 48.255 54.4426C56.4501 44.8474 67.8 38.4912 80.2632 36.5172C92.7264 34.5432 105.485 37.0811 116.244 43.6742C125.996 49.6503 133.525 58.6026 137.753 69.1629C138.478 70.9743 140.46 71.9954 142.316 71.3925L169.198 62.6582C171.053 62.0552 172.076 60.0588 171.399 58.2286C164.539 39.6734 151.63 23.9219 134.704 13.5498C116.773 2.56112 95.5083 -1.66862 74.7363 1.62134C53.9642 4.91129 35.0477 15.505 21.3892 31.4971C7.7307 47.4892 0.226568 67.83 0.226563 88.8609C0.226557 109.892 7.73068 130.233 21.3892 146.225C25.8999 151.506 30.9841 156.199 36.5191 160.234L32.3926 205.099L91.6741 177.133C106.8 176.598 121.637 172.18 134.704 164.172C151.63 153.8 164.538 138.049 171.399 119.493Z",
    fill: "#E4E5F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatLogoHuge);
export default __webpack_public_path__ + "static/media/chat-logo-huge.071425a97a78da8362f789237a3e89b0.svg";
export { ForwardRef as ReactComponent };